import { render, staticRenderFns } from "./empower.vue?vue&type=template&id=9c96bb30&scoped=true&"
import script from "./empower.vue?vue&type=script&lang=js&"
export * from "./empower.vue?vue&type=script&lang=js&"
import style0 from "./empower.vue?vue&type=style&index=0&id=9c96bb30&prod&lang=css&"
import style1 from "./empower.vue?vue&type=style&index=1&id=9c96bb30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c96bb30",
  null
  
)

export default component.exports